import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import KuposModal from './KuposModal';
import SvgHome from './SvgHome';
import KuposButton from './KuposButton';
import KuposInput from './KuposInput';
import CommonService from '../../services/commonService';
import DateService from '../../services/dateService';
import { AppData } from '../../services';

export class EditBipCard extends Component {
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    t: PropTypes.func,
    userCards: PropTypes.object.isRequired,
    selectedItemForEdit: PropTypes.number.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      cardName: null,
      cardNumber: null,
    };
  }

  componentDidMount() {
    this.setState({
      cardName: this.props.selectedItemForEdit && this.props.selectedItemForEdit.card_name,
      cardNumber: this.props.selectedItemForEdit && this.props.selectedItemForEdit.card_number,
    });
  }

  // getName = (val, key) => {
  //   return this.props.selectedItemForEdit === key ? val.name : '';
  // };

  // getCardNumber = (val, key) => {
  //   return this.props.selectedItemForEdit === key ? val.cardNumber : '';
  // };

  onBipCardNameChange = val => {
    this.setState({ cardName: val, cardNameError: null });
  };

  onBipCardNameBlur = val => {
    if (!val) {
      this.setState({ cardNameError: { message: 'VALIDATIONS.BIP_CARD_NAME' } });
    }
  };

  onUpdate = () => {
    if (!this.state.cardName) {
      this.setState({ cardNameError: { message: 'VALIDATIONS.BIP_CARD_NAME' } });
      return;
    }

    console.log('All gfood and props are ', this.props);

    let data = {
      id: this.props.selectedItemForEdit.id,
      user_id: this.props.selectedItemForEdit.user_id,
      user_name: this.props.selectedItemForEdit.user_name,
      user_image: this.props.selectedItemForEdit.user_image,
      contact_no: this.props.selectedItemForEdit.contact_no,
      email: this.props.selectedItemForEdit.email,
      status: this.props.selectedItemForEdit.status,
      card_name: this.state.cardName,
      card_number: this.props.selectedItemForEdit.card_number,
      verification_status: this.props.selectedItemForEdit.verification_status,
      remarks: 'Test Remark',
      add_time_milli_secs: this.props.selectedItemForEdit.add_time_milli_secs,
      add_date_stg: this.props.selectedItemForEdit.add_date_stg,
      add_time_stg: this.props.selectedItemForEdit.add_time_stg,
      delete_time_milli_secs: 0,
      delete_date_stg: '',
      delete_time_stg: '',
      update_time_milli_secs: DateService.getUTC(),
      update_date_stg: DateService.getTodayString(),
      update_time_stg: `${DateService.getCurrentHour()}.${DateService.getCurrentMinute()}`,
    };

    console.log('Update data to send ', data);

    this.props.actions
      .apiCall({
        url: AppData.BIP_URL + 'api/v1/myCard',
        method: 'PUT',
        data: data,
      })
      .then(
        res => this.onBipCardsUpdateResponse(res),
        err => this.onBipCardsUpdateResponse(err),
      );
  };

  onBipCardsUpdateResponse = result => {
    console.log('On update card', result);
    this.props.onBipCardUpdate(result);
  };

  render() {
    console.log('Edit Item in edit popup', this.props);

    // {
    //   this.props.userCards
    //     ? this.props.userCards.map((val, key) => this.getDetails(val, key))
    //     : null;
    // }
    return (
      <div className="common-edit-bip-card">
        <KuposModal
          showModal={this.props.showModal}
          onHide={this.props.onHide}
          size="md"
          ariaLabel="login-modal"
        >
          <div className="login-signup-block delete-bip-card">
            <div className="close-button pointer" onClick={this.props.onHide}>
              <SvgHome name="close" />
            </div>

            <div>
              <span className="bold-text font12 bip-pop-up-title-edit">
                {this.props.t('PROFILE.MODIFY_CARD_TITLE')}
              </span>
              <div className="add-bip-card-input-container">
                <div className="add-bip-card-input-container-inner">
                  <div className="bip-input-add-container">
                    <div className="recarge-input-label font10 bold-text edit-bip-card-inout-label">
                      {this.props.t('PROFILE.NAME')}
                    </div>

                    <KuposInput
                      placeholder={this.props.t('PROFILE.NAME_ENTER_PLACEHOLDER')}
                      className="kupos-border font10 bip-recharge-input add-bip-input"
                      value={this.state.cardName}
                      onChange={text => this.onBipCardNameChange(text)}
                      onBlur={text => this.onBipCardNameBlur(text)}
                      error={this.state.cardNameError && this.state.cardNameError ? true : false}
                      errorMessage={
                        this.state.cardNameError && this.state.cardNameError
                          ? this.props.t(this.state.cardNameError.message)
                          : ''
                      }
                      // onBlur={() => {}}
                      // onChange={val => this.setState({ rechargeAmount: val })}
                    />
                  </div>

                  <div className="bip-input-add-container">
                    <div className="recarge-input-label font10 bold-text edit-bip-card-inout-label-1">
                      {this.props.t('PROFILE.CARD_NUMBER')}
                    </div>

                    <KuposInput
                      placeholder="XXXXXXXX"
                      className="kupos-border font10 bip-recharge-input add-bip-input "
                      value={this.state.cardNumber}
                      disabled={true}
                      // value={CommonService.removeCommas(
                      //   this.props.userCards
                      //     ? this.props.userCards.map((val, key) => this.getCardNumber(val, key))
                      //     : null,
                      // )}
                      // onBlur={() => {}}
                      // onChange={val => this.setState({ rechargeAmount: val })}
                    />
                  </div>
                </div>
              </div>

              <div className=" edit-bip-button bip-popup-button-container-edit">
                <KuposButton
                  onClick={this.onUpdate}
                  className="bip-popup-button1 font12 bip-edit-button"
                >
                  {this.props.t('PROFILE.SAVE_CHANGES_BUTTON')}
                </KuposButton>
              </div>
            </div>
          </div>
        </KuposModal>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditBipCard);



// WEBPACK FOOTER //
// ./src/features/common/EditBipCard.js